/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../common/checking_direct_deposit_account/checking_direct_deposit_account';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "checking": {
                "nested": {
                  "DeactivateCheckingRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "DeactivateCheckingResponse": {
                    "fields": {}
                  },
                  "DashboardWebCheckingService": {
                    "methods": {
                      "DeactivateChecking": {
                        "requestType": ".squareup.bbfrontend.dashboard.checking.DeactivateCheckingRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.checking.DeactivateCheckingResponse"
                      },
                      "GetCheckingDirectDepositAccount": {
                        "requestType": ".squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountRequest",
                        "responseType": ".squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.checking?.nested?.DeactivateCheckingRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.checking?.nested?.DeactivateCheckingResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.checking?.nested?.DashboardWebCheckingService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeactivateCheckingRequest @ squareup/bbfrontend/dashboardweb/checking/checking_service.proto at 23:1
 */
export const DeactivateCheckingRequest = $root.lookupType('squareup.bbfrontend.dashboard.checking.DeactivateCheckingRequest');
fixType(DeactivateCheckingRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeactivateCheckingRequest);
/**
 * SOURCE DeactivateCheckingResponse @ squareup/bbfrontend/dashboardweb/checking/checking_service.proto at 27:1
 */
export const DeactivateCheckingResponse = $root.lookupType('squareup.bbfrontend.dashboard.checking.DeactivateCheckingResponse');
fixType(DeactivateCheckingResponse);
Builder.createAndAttachToType(DeactivateCheckingResponse);
/**
 * SOURCE DashboardWebCheckingService @ squareup/bbfrontend/dashboardweb/checking/checking_service.proto at 13:1
 */
export const DashboardWebCheckingService = $root.lookupService('squareup.bbfrontend.dashboard.checking.DashboardWebCheckingService');